import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import { styled } from 'styled-components';
import { ImgFolder } from '@fabric-app/icons/old';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { mediaMobile } from '@fabric-app/ui/constants/styled-utils';

const DestinationButtonBase = styled.button.withConfig({
  displayName: "DestinationButton__DestinationButtonBase",
  componentId: "sc-86deded0-0"
})([
  `width:200px;border-radius:40px;border:1px dashed `,
  `;background:`,
  `;display:flex;height:38px;padding:10px 16px;align-items:center;gap:8px;flex:1 0 0;> span{flex-grow:1;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;text-align:start;}position:absolute;bottom:-70px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,0.3);color:white;transition:0.2s all;&:hover{background:rgba(0,0,0,0.33);}`,
  `{position:static;min-width:200px;width:auto;flex-grow:1;margin-right:auto;transform:none;color:`,
  `;background:none;}`
], cssVar["color-border-primary"], cssVar["color-bg-secondary"], mediaMobile, cssVar["color-text-primary"]);
const DestinationButton = /* @__PURE__ */ React__default.forwardRef(({ destinationParent, handleOpenDestinationFolder, ...props }, ref) => {
  return /* @__PURE__ */ jsxs(DestinationButtonBase, {
    "data-testid": "destination-button",
    onClick: handleOpenDestinationFolder,
    type: "button",
    ref,
    ...props,
    children: [
      /* @__PURE__ */ jsx("img", {
        src: ImgFolder,
        alt: "Folder",
        width: 16
      }),
      /* @__PURE__ */ jsx("span", {
        children: destinationParent?.name
      })
    ]
  });
});
DestinationButton.displayName = "DestinationButton";

export { DestinationButton };
//# sourceMappingURL=DestinationButton.js.map
